<div class="ticket-wrapper booking-slots-wrapper generic-dialog">
  <div class="generic-buying-tickets-cont">
    <div class="book-event-slot-content payment-content" mat-dialog-content>
      <div class="dialog-header">
        <div class="dialog-title-with-progress-cont">
          <div class="dialog-title-custom">
            {{ "APP.CLAIM_TICKET_DIALOG.TITLE" | translate }}
          </div>
        </div>

        <div class="close-button-custom">
          <i class="far fa-times icon-regular" (click)="close()"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div>
          @if (ticket) {
            <div class="generic-get-tickets-wrapper">
              @if (!isDesktop && event && ticket) {
                <div class="inline-overview-cont">
                  <div class="inline-event-info">
                    <div class="name">
                      {{ event.name }} | {{ ticket.getTicketName() }}
                    </div>
                    <div class="date">
                      @if (ticket.eventAttendeeTicketOrder?.eventSlot) {
                        {{
                          ticket.eventAttendeeTicketOrder?.eventSlot?.getSlotDateDisplay(
                            currentLang
                          )
                        }}
                      } @else {
                        {{ event.getDisplayDate() }}
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="item payment">
                <ng-container *ngTemplateOutlet="payment"></ng-container>
              </div>
            </div>
          }
        </div>
      </div>
      <div mat-dialog-actions class="dialog-actions column-actions">
        <button
          class="btn btn-primary pop-color"
          [disabled]="!isStepValid || inProgress"
          [class.spinner]="inProgress"
          (click)="claimTicket()"
        >
          {{ "APP.CLAIM_TICKET_DIALOG.SAVE_DATA" | translate }}
        </button>
      </div>
    </div>

    <div class="item overview-card">
      <div class="overview-card-content">
        <!--Event info-->
        <ng-container *ngTemplateOutlet="eventInfo"></ng-container>

        <!--Total price section-->
        <ng-container *ngTemplateOutlet="orderOverview"></ng-container>
      </div>
    </div>

    <ng-template #eventInfo>
      @if (event && ticket) {
        <div class="event-info-wrapper">
          <div class="event-image-wrapper">
            <div class="overlay">
              <img
                [src]="event.getEncodedMainImage(true)"
                class="key-visual-img"
                alt="Key Visual"
              />
            </div>
            <img
              [src]="event.getEncodedMainImage(true)"
              class="key-visual-img logo-image"
              alt="Key Visual"
            />
          </div>
          <div class="event-info">
            <div class="name">
              {{ event.name }} |
              {{ ticket.getTicketName() }}
            </div>
            <div class="date-address">
              <div class="date">
                @if (ticket.eventAttendeeTicketOrder?.eventSlot) {
                  {{
                    ticket.eventAttendeeTicketOrder?.eventSlot?.getSlotDateDisplay(
                      currentLang
                    )
                  }}
                } @else {
                  {{ event.getDisplayDate() }}
                }
              </div>
              <div class="location-wrapper">
                <div class="icon">
                  <i class="fal fa-map-marker-alt"></i>
                </div>
                <div class="item">
                  <div class="item-title">
                    {{ event.getAddressDisplayNamePrimary() }}
                  </div>
                  <div class="value">
                    {{ event.getAddressDisplayNameSecondary() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>

    <ng-template #orderOverview>
      <div class="selection-footer">
        <div class="divider"></div>
        <div class="order-item-wrapper">
          <div class="item">
            <div>1x {{ ticket?.getTicketName() }}</div>
          </div>
        </div>
        <div class="description" [ngClass]="{ truncated: !expanded }">
          {{ ticket?.getTicketDescription() }}
        </div>
        @if(ticket?.getTicketDescription()){
          <a class="toggle-link" (click)="expanded = !expanded">
            @if (expanded) {
              {{ "APP.TICKETING.READ_LESS" | translate }}
            } @else {
              {{ "APP.TICKETING.READ_MORE" | translate }}
            }
          </a>
        }

      </div>
    </ng-template>

    <ng-template #payment>
      <app-event-payment
        [event]="event"
        [ticketToClaim]="ticket"
        [isGeneric]="true"
        [isBookASlot]="true"
        [isClaimTicket]="true"
        [accountRequirement]="
          ticket?.eventAttendeeTicketOrder?.eventSlot?.accountRequirement
        "
        [canPay]="false"
        [isAssignToMe]='isAssignToMe'
        [eventAttendee]='ticket?.eventAttendee'
        (claimTicketSuccess)="claimTicketSuccess($event)"
      />
    </ng-template>
  </div>
</div>
